module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"人数":"人数"},"en":{"人数":"number of people"}}')
  delete Component.options._Ctor
}
